const PaymentPageHandler = (product, event, data) => {
    const { metaData = {}, url = '', journeyInfo = {}, currMode = '' } = data,
        { as = {}, ds = {}, quota = '', avlclass = [], avlclassavl = {} } = journeyInfo,
        { code: originCode = '', name: originName = '' } = as,
        { code: destinationCode = '', name: destinationName = '' } = ds,
        [firstClass = ''] = avlclass,
        classavl = avlclassavl[firstClass] || {},
        { ravail = [] } = classavl,
        [price = {}] = ravail,
        { pi = {} } = price,
        { fc = {} } = pi,
        { TF = 0 } = fc,
        { userId } = metaData;

    let finalData = {
        userId: userId, urlPath: url, product: product, originCode, originName, destinationCode, destinationName,
        quota, journeyClass: firstClass, fare: TF
    }
    //Agent charges 
    //TJ PG Fee

    switch (event) {
        case 'PageView':
            break;
        case 'ProceedToPay':
            finalData = { ...finalData, paymentMode: currMode, bookingInitiated: true }
            break;
    }
    return finalData;

}

module.exports = { PaymentPageHandler }